import React from 'react';
import { motion } from 'framer-motion';
import './Technologies.css';

// Import logo images
import androidLogo from '../../assets/images/logo/android.png';
import reactLogo from '../../assets/images/logo/react.png';
import reactNativeLogo from '../../assets/images/logo/react-native.png';
import flutterLogo from '../../assets/images/logo/flutter.png';
import nodejsLogo from '../../assets/images/logo/nodejs.png';
import graphqlLogo from '../../assets/images/logo/graphql.png';
import mysqlLogo from '../../assets/images/logo/mysql.jpg';
import mongodbLogo from '../../assets/images/logo/mongodb.png';
import websocketsLogo from '../../assets/images/logo/websockets.png';
import dockerLogo from '../../assets/images/logo/docker.png';
import firebaseLogo from '../../assets/images/logo/firebase.png';
import awsLogo from '../../assets/images/logo/aws.png';
import appstoreLogo from '../../assets/images/logo/appstore.jpeg';
import playstoreLogo from '../../assets/images/logo/playstore.png';
import javaScriptLogo from '../../assets/images/logo/javascript.png';
import typescriptLogo from '../../assets/images/logo/typescript.png';
import phpLogo from '../../assets/images/logo/php.png';
import cdLogo from '../../assets/images/logo/CICD.png';

const technologies = [
  { name: 'Android', logo: androidLogo },
  { name: 'React Native', logo: reactNativeLogo },
  { name: 'Flutter', logo: flutterLogo },
  { name: 'Firebase', logo: firebaseLogo },
  { name: 'App Store', logo: appstoreLogo },
  { name: 'Play Store', logo: playstoreLogo },
  
  { name: 'JavaScript', logo: javaScriptLogo },
  { name: 'TypeScript', logo: typescriptLogo },
  { name: 'React.js', logo: reactLogo },
  { name: 'Node.js', logo: nodejsLogo },
  { name: 'MongoDB', logo: mongodbLogo },
  { name: 'GraphQL', logo: graphqlLogo },
  { name: 'PHP', logo: phpLogo },
  { name: 'MySQL', logo: mysqlLogo },
  { name: 'WebSockets', logo: websocketsLogo },
  { name: 'Docker', logo: dockerLogo },
  { name: 'AWS', logo: awsLogo },
  { name: 'CI/CD', logo: cdLogo },
  
];

const Technologies: React.FC = () => {
  return (
    <section className="section technologies-section" id="technologies">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Technologies We Use</h2>
          <p className="section-subtitle">
            Modern tech stack for building robust and scalable applications
          </p>
          
          <div className="technologies-grid">
            {technologies.map((tech, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="tech-item"
              >
                <div className="tech-icon">
                  <img src={tech.logo} alt={tech.name} className="tech-logo" />
                </div>
                <span className="tech-name">{tech.name}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Technologies; 